import { withInstall } from '@ll-plus/utils'

import TreeSelect from './src/tree-select.vue'

export const LlTreeSelect = withInstall(TreeSelect)
export default LlTreeSelect
export * from './src/tree-select'

declare module 'vue' {
  export interface GlobalComponents {
    LlTreeSelect: typeof TreeSelect
  }
}
